import { CHECK_IN_ERROR } from '@mutations'
import { CheckInApiService } from '@common/ApiService'

export const state = {
  errors: null,
  progress: null,
}

export const mutations = {
  [CHECK_IN_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },
}

export const actions = {
  onCreate({ commit, dispatch }, { journeyLegId, notes, requestId }) {
    return CheckInApiService.create({
      journey_leg_id: journeyLegId,
      notes,
    })
      .then(() => {
        return dispatch('requests/show', requestId, { root: true })
      })
      .catch((e) => commit(CHECK_IN_ERROR, e))
  },

  onUpdate({ commit, dispatch }, { id, notes, requestId }) {
    return CheckInApiService.update(id, {
      notes,
    })
      .then(() => {
        return dispatch('requests/show', requestId, { root: true })
      })
      .catch((e) => commit(CHECK_IN_ERROR, e))
  },
}
